import React,{ useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import AddButton from './addButton';
import { Form } from 'react-bootstrap';
import { FaPencil } from "react-icons/fa6";
import { MdAdd } from "react-icons/md";
import UserButton from './userButton'


function CreateTask({show, handleClose}) {
  const [inputValue, setInputValue] = useState('');
  const [showAddModal, setShowAddModal] = useState(false);
  const [showUserModal, setShowUserModal] = useState(false);
  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };
  const [selectedRole, setSelectedRole] = useState('');
  const handleRoleChange = (event) => {
    setSelectedRole(event.target.value);
  };

  const handleShowAdd = () => setShowAddModal(true);
  const handleAddCloseModal = () => setShowAddModal(false);

  const handleShowUser = () => setShowUserModal(true);
  const handleUserCloseModal = () => setShowUserModal(false);

  const dropdownStyling = {
    padding: '3px',
    fontSize: '0.9rem',
    border: '1px solid #ccc',
    borderRadius: '5px',
    outline: 'none',
    color: '#333',
    width: '200px',
    height: '31px',
    cursor: 'pointer',
    marginLeft: '40px',
  };
  const [inputValued, setInputValued] = useState('');
  const handleInputChanged = (event) => {
    setInputValued(event.target.value);
  };
  const [selectedRoled, setSelectedRoled] = useState('');
  const handleRoledChange = (event) => {
    setSelectedRoled(event.target.value);
  };
  const dropdownStyled = {
    padding: '3px',
    fontSize: '0.9rem',
    border: '1px solid #ccc',
    borderRadius: '5px',
    outline: 'none',
    color: '#333',
    width: '200px',
    height: '31px',
    cursor: 'pointer',
    marginLeft: '10px',
  };
  const [selectedRoling, setSelectedRoling] = useState('');
  const handleRolingChange = (event) => {
    setSelectedRoling(event.target.value);
  };
  const dropdownStyleded = {
    padding: '3px',
    fontSize: '0.9rem',
    border: '1px solid #ccc',
    borderRadius: '5px',
    outline: 'none',
    color: '#333',
    width: '200px',
    height: '31px',
    cursor: 'pointer',
    marginLeft: '57px',
  };

  return (
    <Modal show={show} onHide={handleClose} dialogClassName="modal-90w" centered size="lg">
      <Modal.Header closeButton style={{ backgroundColor: '#004aad' }}>
        <Modal.Title className='heading' style={{ color: 'white' }}></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <b style={{ fontSize: "24px" }}>Add Task</b>
        <br/>
        <br/>
        <h4>Task Details</h4>
        <div style={{
          alignItems: 'center',
          fontSize: '0.9rem',
          marginRight: '20px',
          gap: '50px',
          backgroundColor: '#f2f2f2'
        }}>
          <br/>
          <strong style={{marginLeft:"10px"}}>Name *</strong>
          <input
            type="text"
            value={inputValue}
            onChange={handleInputChange}
            style={{
              padding: '8px',
              fontSize: '15px',
              border: '1px solid #ccc',
              borderRadius: '4px',
              outline: 'none',
              width: '200px',
              height: "35px",
              marginLeft: "75px"
            }} />
          <br />
          <br />
          <strong style={{marginLeft:"6px"}}> Department </strong>
          <select value={selectedRole} onChange={handleRoleChange} style={dropdownStyling}>
            <option value="CROWN AND BRIDGE">CROWN AND BRIDGE</option>
            <option value="PROSTHETICS">PROSTHETICS</option>
            <option value="ORTHODONTIC">ORTHODONTIC</option>
            <option value="IMPLANTS">IMPLANTS</option>
            <option value="COBALT CHROME">COBALT CHROME</option>
            <option value="VALPLAST">VALPLAST</option>
            <option value="PLASTER ROOM">PLASTER ROOM </option>
            <option value="ALL DEPARTMENTS">ALL DEPARTMENTS</option>
          </select>
          <br/>
          <br/>
          <strong style={{marginLeft:"6px"}}>Progress Stages</strong>
          <select value={selectedRoled} onChange={handleRoledChange} style={dropdownStyled}>
            <option value=""></option>
            <option value=""></option>
            <option value=""></option>
            <option value=""></option>
          </select>
          <br/>
          <br/>
          <strong style={{marginLeft:"10px"}}>Pay Amount (£)</strong>
          <input
            type="number"
            placeholder=""
            style={{
              border: '2px solid #ccc',
              borderRadius: '4px',
              padding: '8px',
              width: '85px',
              height: '35px',
              marginLeft: '14px'
            }}
          />
          <br/>
          <br/>
          <div style={{ display: 'flex', alignItems: 'center', marginLeft: '10px' }}>
          <strong style={{ marginRight: '10px' }}>Task Completion</strong>
  <Form.Check
    type="checkbox"
    aria-label="Toggle input field"
  />
  <p style={{ margin: '0 10px' }}>Task completion page, allow Out-of-order scanning</p>
</div>  <br/>
<div style={{ display: 'flex', alignItems: 'center' }}>
          <Form.Check
            type="checkbox"
            aria-label="Toggle input field"
            style={{ marginLeft: '135px' }}
          />  <p  style={{ margin: '0 10px' }}>Case Task Chart, Allow Out-of-order checking</p></div>  <br/>
          <div style={{ display: 'flex', alignItems: 'center' }}>
          <Form.Check
            type="checkbox"
            aria-label="Toggle input field"
            style={{ marginLeft: '135px' }}
          />      <p  style={{ margin: '0 10px' }}> Complete all instances of this task.</p></div>  <br/>
          <strong style={{marginLeft:"10px"}}>Custom ID</strong> <input
            type="text"
            value={inputValued}
            onChange={handleInputChanged}
            style={{
              padding: '8px',
              fontSize: '15px',
              border: '1px solid #ccc',
              borderRadius: '4px',
              outline: 'none',
              width: '200px',
              height: "35px",
              marginLeft: "50px",
            }} />
              <br/>
              <br/>
        </div>
        <br/>
        <h4>Task Scheduling</h4>
        <div style={{
          alignItems: 'center',
          fontSize: '0.9rem',
          marginRight: '20px',
          gap: '50px',
          backgroundColor: '#f2f2f2'
        }}>
<br/> 
         
          <div style={{ display: 'flex', alignItems: 'center' }}> <strong style={{marginLeft:"10px"}}>Daily Limit</strong>
          <input
            type="number"
            placeholder=""
            style={{
              border: '2px solid #ccc',
              borderRadius: '4px',
              padding: '8px',
              width: '90px',
              height: '37px',
              marginLeft: '61px'
            }}
          />  <p  style={{ margin: '0 10px' }}> Task Blocks</p></div><br/> 
          <div style={{ display: 'flex', alignItems: 'center' }}>  <Form.Check
            type="checkbox"
            aria-label="Toggle input field"
            style={{ marginLeft: '140px' }}
          /><p  style={{ margin: '0 10px' }}> Count toward department capacity</p></div>
          <br/>
          <strong style={{marginLeft:"10px"}}>Task Units</strong>
          <select value={selectedRoling} onChange={handleRolingChange} style={dropdownStyleded}>
            <option value="">Inherit Procedure Unit</option>
            <option value="">Count Procedure Teeth</option>
            <option value="">AccountProcedure Arches</option>
            <option value="">1</option>
          </select>
          <br/>
          <br/>
          <strong style={{marginLeft:"10px"}}>Turn Around Days</strong>
          <br></br>
          <Button
        variant="secondary"
        onClick={handleShowAdd}
        style={{
          backgroundColor: '#004aad',
          borderColor: '#004aad',
          marginLeft: "650px"
        }}
      >
       <MdAdd/>
       Add
          
          </Button>
          <AddButton showModal={showAddModal} handleCloseModal={handleAddCloseModal} />
          <br />
          <br />
          <p style={{marginLeft:"40px"}}>Showing 0 to 0 of 0 entries</p>
          <b  style={{marginLeft:"30px"}}>Days</b> <b  style={{marginLeft:"30px"}}>Same Day</b><b  style={{marginLeft:"30px"}}>Decision Point</b>
          <br/>
          <br/>
          <p style={{marginLeft:"40px"}}>Showing 0 to 0 of 0 entries</p><br/>
        </div>
        <br/>
        <h4>Task-User Scheduling</h4>
        <div style={{
          alignItems: 'center',
          fontSize: '0.9rem',
          marginRight: '20px',
          gap: '50px',
          backgroundColor: '#f2f2f2',
          display: 'flex',
        }}>
          <br/>
          <br/>
          <Form.Check
            type="checkbox"
            aria-label="Toggle input field"
            style={{ marginLeft: '95px' }}
          /> <p style={{ margin: '0 10px'}}>This is an assignable task</p>
          <br/>
          <br/>
        </div>
        <br/>
        <h4>User Payment Details </h4>
        <div style={{
          alignItems: 'center',
          fontSize: '0.9rem',
          marginRight: '20px',
          gap: '50px',
          backgroundColor: '#f2f2f2'
        }}><br/>
          <Button
        variant="secondary"
        onClick={handleShowUser}
        style={{
          backgroundColor: '#004aad',
          borderColor: '#004aad',
          marginLeft: "650px"
        }}
      >
       <MdAdd/>
       Add
          </Button>
          <UserButton showModal={showUserModal} handleCloseModal={handleUserCloseModal}/>
          <p style={{marginLeft:"30px"}}>Showing 0 to 0 of 0 entries</p>
          <b style={{marginLeft:"30px"}}>Name</b> <b style={{marginLeft:"60px"}}>Amount</b><br/><br/>
        </div>
        <p style={{marginLeft:"300px",fontSize:"14px"}}>No data available in table</p>
        <div style={{
          alignItems: 'center',
          fontSize: '0.9rem',
          marginRight: '20px',
          gap: '50px',
          backgroundColor: '#f2f2f2'
        }}><br/>
          <p style={{marginLeft:"20px"}}>Showing 0 to 0 of 0 entries</p><br/>
        </div>
        <br/>
        <h4>Process Improvement Issues</h4>
        <br/>
        <div style={{
          alignItems: 'center',
          fontSize: '0.9rem',
          marginRight: '20px',
          gap: '50px',
          backgroundColor: '#f2f2f2'
        }}>
        <br/>  <p style={{marginLeft:"20px"}}>Showing 0 to 0 of 0 entries</p>
          <b style={{marginLeft:"30px"}}>Name</b><br/><br/>
        </div>
        <p style={{marginLeft:"300px",fontSize:"14px"}}>No data available in table</p>
        <div style={{
          alignItems: 'center',
          fontSize: '0.9rem',
          marginRight: '20px',
          gap: '50px',
          backgroundColor: '#f2f2f2'
        }}><br/>
          <p style={{marginLeft:"30px"}}>Showing 0 to 0 of 0 entries</p><br/>
        </div>
      </Modal.Body>
      <Button
        variant="secondary"
        onClick={handleClose}
        style={{
          backgroundColor: '#004aad',
          borderColor: '#004aad',
          marginLeft: "700px",
          marginRight:"5px"
        }}
      >
       <FaPencil />
       Save
      </Button>
      <br/>
    </Modal>
  );
}

export default CreateTask; 